import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SmallBusinessEcommerceWebSolutionsInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Small Business E-commerce Web Solutions in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Your Small Business</Subheading>}
        heading={
          <Heading>
            Small Business{" "}
            <span tw="text-primary-500">E-commerce Web Solutions</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset provides tailored e-commerce web solutions for small
            businesses in **Al Barsha**, offering affordable, user-friendly
            online stores to boost sales and visibility.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small business owner with laptop
          "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small shop with products
          "https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Local business success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Empowering Small Businesses"
        description="Our solutions are designed for growth and simplicity."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Affordable Plans",
            description: "Budget-friendly for startups.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Easy Management",
            description: "Intuitive store controls.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly",
            description: "Shop seamlessly on any device.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Payments",
            description: "Safe transactions for trust.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Launch quickly and sell.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Support",
            description: "Local experts for your needs.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Help</Subheading>}
        heading="Our Small Business E-commerce Process"
        description={
          <Description>
            We simplify online success for small businesses:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your business goals.</li>
              <li>Design: Create a user-friendly, branded store.</li>
              <li>Development: Build with affordable tools.</li>
              <li>Testing: Ensure smooth functionality.</li>
              <li>Launch: Get your store live fast.</li>
              <li>Support: Guide you as you grow.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small team planning
          "https://images.unsplash.com/photo-1533750349088-cd871a92f312?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Person working on laptop with coffee
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Mobile shopping experience
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Small Business Success in Al Barsha"
        description="Our solutions transform local businesses."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "35% revenue increase.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Launches",
            description: "Stores live in under a week.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Happiness",
            description: "92% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell?</Subheading>}
        heading="Small Business E-commerce Web Solutions in Al Barsha"
        description={
          <Description>
            MilaajBrandset offers affordable e-commerce web solutions for small
            businesses in Al Barsha, helping you launch and grow online with
            ease. Contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small business in Dubai
          "https://images.unsplash.com/photo-1591085686350-798c0f9faa7f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Person managing online store
          "https://images.unsplash.com/photo-1539189017439-52ea067284a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small shop inventory
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
